document.addEventListener('DOMContentLoaded', () => {
  const generateSvgButton = document.querySelector('#generate-pdf-link');
  const addToCartButton = document.querySelector('button[data-js-product-add-to-cart]');
  const overlay = document.createElement('div');
  overlay.id = 'interaction-blocker';
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
  overlay.style.zIndex = '99999';
  overlay.style.display = 'none';
  document.body.appendChild(overlay);
  
  if (generateSvgButton) {
 generateSvgButton.addEventListener('click', async (event) => {
  console.log("Generate SVG button clicked");
  event.preventDefault();
  event.stopPropagation();
  
  const spinner = document.createElement('span');
  spinner.className = 'spinner';
  generateSvgButton.appendChild(spinner);
  generateSvgButton.disabled = true;
  overlay.style.display = 'block';
  
  try {
    const skuElement = document.getElementById('sku');
    const sku = skuElement ? skuElement.textContent.trim() : 'unknown';
    
    // FARBE holen
    let selectedColorHex = 'unknown';
    let selectedColorLabel = 'unknown';

    const firstLineColorSelect = document.querySelector('.dynamic-select-color');

    if (firstLineColorSelect) {
      const colorInput = firstLineColorSelect.querySelector('.wunschtext-line-color-input');
      if (colorInput && colorInput.value) {
        selectedColorHex = colorInput.value.trim();
      }

      const selectedOption = firstLineColorSelect.querySelector('.dynamic-select-option.dynamic-select-selected');
      if (selectedOption && selectedOption.dataset.label) {
        selectedColorLabel = selectedOption.dataset.label.trim();
      }
    }

    const colorForFileNameRaw = selectedColorLabel !== 'unknown' ? selectedColorLabel : selectedColorHex;
    const colorForFileName = colorForFileNameRaw
      ? colorForFileNameRaw.replace(/\s+/g, '-')
      : 'unknown-color';
    const colorForServer = selectedColorHex;

    // AUSRICHTUNG (normal / gespiegelt)
    const orientationInput = document.querySelector('input[name="properties[Ausrichtung]"]:checked');
    const isMirrored = orientationInput && orientationInput.value === 'gespiegelt';

    const widthInput  = document.getElementById('target-width-cm');
    const heightInput = document.getElementById('target-height-cm');
    
    const width  = widthInput ? widthInput.value : 'unknown';
    const height = heightInput ? heightInput.value : 'unknown';
    
    const svgElement = document.getElementById('svg-path');
    if (!svgElement) {
      throw new Error("SVG element not found");
    }
    
    // SVG-Kopie erstellen, damit wir daran rumspielen können
    const svgClone = svgElement.cloneNode(true);

    // Wenn gespiegelt → echtes SVG spiegeln (nicht nur CSS)
    if (isMirrored) {
      const vb = svgClone.getAttribute('viewBox'); // z.B. "0 0 427.43 401.95"
      let vbWidth = null;
      if (vb) {
        const parts = vb.split(/\s+/);
        if (parts.length === 4) {
          vbWidth = parseFloat(parts[2]); // Breite aus der viewBox
        }
      }

      // <g>-Element erstellen und alle Kinder dort reinpacken
      const svgNS = 'http://www.w3.org/2000/svg';
      const g = document.createElementNS(svgNS, 'g');

      while (svgClone.firstChild) {
        g.appendChild(svgClone.firstChild);
      }

      if (!isNaN(vbWidth) && vbWidth > 0) {
        // Spiegelung an der vertikalen Mittelachse des SVG
        g.setAttribute('transform', `translate(${vbWidth},0) scale(-1,1)`);
      } else {
        // Fallback: trotzdem spiegeln, aber ohne viewBox-Breite
        g.setAttribute('transform', 'scale(-1,1)');
      }

      svgClone.appendChild(g);
    }

    // SVG serialisieren (WICHTIG: die Kopie, nicht das Original)
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgClone);
    const blob = new Blob([svgString], { type: "image/svg+xml" });

    const fileName = `${sku}_${colorForFileName}_${isMirrored ? 'gespiegelt_' : ''}${width}x${height}_${generateRandomId(8)}.svg`;
    
    const pdfUrl = await sendToServer(blob, fileName, sku, colorForServer, width, height);
    if (pdfUrl) {
      setSvgInputValue(pdfUrl);
    }
  } catch (error) {
    console.error('Error generating SVG:', error);
    alert('There was an error generating the SVG. Please try again.');
  } finally {
    spinner.remove();
    generateSvgButton.disabled = false;
    overlay.style.display = 'none';
    if (addToCartButton) {
      addToCartButton.click();
    }
  }
});


  } else {
    console.error('Generate SVG button not found.');
  }
  
  function generateRandomId(length = 8) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join('');
  }
  
  async function sendToServer(svgBlob, fileName, sku, color, width, height) {
    const formData = new FormData();
    formData.append('svgFile', svgBlob, fileName);
    formData.append('sku', sku);
    formData.append('color', color); // <-- jetzt Hex-Wert aus dynamic-select
    formData.append('width', width);
    formData.append('height', height);
    
    const response = await fetch('https://design.my-foil.ch/mw-cloud-convert-svg-pdf.php', {
      method: 'POST',
      body: formData,
    }).catch(error => {
      console.error('Network error:', error);
      alert('There was a network error while uploading the SVG. Please try again.');
      return null;
    });
    
    if (response && response.ok) {
      const data = await response.json();
      console.log('Server Response:', data);
      if (data && data.pdf_link) {
        return data.pdf_link;
      } else {
        console.error('PDF URL not found in the server response:', data);
      }
    }
    return null;
  }
  
  function setSvgInputValue(pdfUrl) {
    const svgInput = document.getElementById('pdf_link');
    if (svgInput) {
      svgInput.value = pdfUrl;
    } else {
      console.error('PDF input field not found');
    }
  }
});
